/**
 * @author Arul Vivek
 */
 import service from '../Common'
 import constants from '../../../settings/shared/constants'
 
 function PostStorageConfiguration(configData) {
     let jwtToken = localStorage.getItem('accessToken');
     let headers = {'Content-Type':'application/json', 'Authorization':'Bearer '+jwtToken}
         return service({
             url: constants.api.storageConfig.postStorageConfig,
             method: 'POST',
             headers: headers,
             data:  configData
         }); 
  }


 function getAllStorageConfig() {
    let jwtToken = localStorage.getItem('accessToken');
    let headers = {'Content-Type':'application/json', 'Authorization':'Bearer '+jwtToken}
        return service({
            url: constants.api.storageConfig.getAllStorageConfig,
            method: 'GET',
            headers: headers,
            data:  ''
        }); 
 }

 function getAllStorageConfigById(id) {
    let jwtToken = localStorage.getItem('accessToken');
    let headers = {'Content-Type':'application/json', 'Authorization':'Bearer '+jwtToken}
        return service({
            url: constants.api.storageConfig.getAllStorageConfigbyId+id,
            method: 'GET',
            headers: headers,
            data:  ''
        }); 
 }


 function UpdateStorageConfig(id,configData) {
    let jwtToken = localStorage.getItem('accessToken');
    let headers = {'Content-Type':'application/json', 'Authorization':'Bearer '+jwtToken}
        return service({
            url: constants.api.storageConfig.updateStorageConfig+id,
            method: 'PUT',
            headers: headers,
            data:  configData
        }); 
 }

 function deleteStorageConfig(id) {
    let jwtToken = localStorage.getItem('accessToken');
    let headers = {'Content-Type':'application/json', 'Authorization':'Bearer '+jwtToken}
        return service({
            url: constants.api.storageConfig.deleteStorageConfigbyId+id,
            method: 'DELETE',
            headers: headers,
            data:  ""
        }); 
 }
 
  
 //To export authentication function
 const StorageConfigService = {
    PostStorageConfiguration,
    getAllStorageConfig,
    getAllStorageConfigById,
    UpdateStorageConfig,
    deleteStorageConfig
 }
 
 export default StorageConfigService;
 